define.alias("ember-concurrency/helpers/task", "settings/helpers/task");